import React, { useEffect, useState } from "react";
import axios from "axios";
import "./ShopSettingsPage.css";
import { getCurrentShopId } from "./auth";

const BACKEND_API_URL =
  process.env.REACT_APP_API_URL || "https://api.deskpos.ie";

  const getAuthConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("pos_token")}`,
  },
});

function ShopSettingsPage() {
 const [settings, setSettings] = useState({
  receipt_name: "",
  address_line_1: "",
  address_line_2: "",
  phone: "",
  vat_number: "",
  vatNumber: "",
  printer_name: "",
  receipt_footer: "",
});

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [shopId, setShopId] = useState(null);

  useEffect(() => {
    const currentShopId = getCurrentShopId();

    console.log("ShopSettingsPage current admin shop id:", currentShopId);

    setShopId(currentShopId);
  }, []);

  useEffect(() => {
    if (!shopId) return;

    loadSettings();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId]);

  const loadSettings = async () => {
    if (!shopId) return;

    try {
      setError("");

      const res = await axios.get(`${BACKEND_API_URL}/shop-settings`, {
  params: { shop_id: shopId },
  ...getAuthConfig(),
});

      console.log("SHOP SETTINGS FOR SHOP:", shopId);
      console.log("SHOP SETTINGS DATA:", res.data);

      const vatValue = res.data.vat_number || res.data.vatNumber || "";

      setSettings({
        receipt_name: res.data.receipt_name || "",
        address_line_1: res.data.address_line_1 || "",
        address_line_2: res.data.address_line_2 || "",
        phone: res.data.phone || "",

        vat_number: vatValue,
        vatNumber: vatValue,

       
        printer_name: res.data.printer_name || "",
        receipt_footer: res.data.receipt_footer || "",
      });
    } catch (err) {
      console.error(
        "Load shop settings error:",
        err.response?.data || err.message
      );
      setError(
  err.response?.data?.error ||
    err.message ||
    "Failed to load shop settings"
);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const saveSettings = async () => {
    if (!shopId) {
      setError("Shop ID not found. Please logout and login again.");
      return;
    }

    try {
      setMessage("");
      setError("");

      const vatValue = settings.vat_number || settings.vatNumber || "";

      const payload = {
        receipt_name: settings.receipt_name,
        address_line_1: settings.address_line_1,
        address_line_2: settings.address_line_2,
        phone: settings.phone,

       
        printer_name: settings.printer_name,
        receipt_footer: settings.receipt_footer,

        /* shop_id: shopId,
        shopId, */

        vat_number: vatValue,
        vatNumber: vatValue,
      };

      console.log("SAVING SHOP SETTINGS:", payload);

     const res = await axios.post(
  `${BACKEND_API_URL}/shop-settings`,
  payload,
  getAuthConfig()
);

      const data = res.data || {};

      console.log("SHOP SETTINGS SAVED:", data);

      const savedVatValue =
        data.vat_number || data.vatNumber || payload.vat_number || "";

      setSettings({
        receipt_name: data.receipt_name || payload.receipt_name || "",
        address_line_1: data.address_line_1 || payload.address_line_1 || "",
        address_line_2: data.address_line_2 || payload.address_line_2 || "",
        phone: data.phone || payload.phone || "",

        vat_number: savedVatValue,
        vatNumber: savedVatValue,

        
        printer_name: data.printer_name || payload.printer_name || "",
        receipt_footer: data.receipt_footer || payload.receipt_footer || "",
      });

      setMessage("Shop settings saved successfully");

      setTimeout(() => {
        setMessage("");
      }, 2500);
    } catch (err) {
      console.error(
        "Save shop settings error:",
        err.response?.data || err.message
      );
      setError(err.response?.data?.error || "Failed to save shop settings");
    }
  };

  return (
    <div className="shop-settings-page">
      <div className="settings-header">
        <div>
          <h1 style={{ color: "#FFF" }}>Shop Settings</h1>
         <p>Manage receipt details and printer options.</p>
        </div>

        <div className="settings-badge">Shop ID: {shopId || "-"}</div>
      </div>

      <div className="settings-card">
        <h2>Receipt Details</h2>

        <div className="settings-grid">
          <div className="settings-field">
            <label>Receipt Name</label>
            <input
              name="receipt_name"
              value={settings.receipt_name}
              onChange={handleChange}
              placeholder="Nearby Store"
            />
          </div>

          <div className="settings-field">
            <label>Phone</label>
            <input
              name="phone"
              value={settings.phone}
              onChange={handleChange}
              placeholder="01 839 3765"
            />
          </div>

          <div className="settings-field">
            <label>VAT Number</label>
            <input
              type="text"
              name="vat_number"
              value={settings.vat_number || ""}
              onChange={(e) => {
                const value = e.target.value;

                setSettings((prev) => ({
                  ...prev,
                  vat_number: value,
                  vatNumber: value,
                }));
              }}
              placeholder="IE1234567A"
            />
          </div>

          <div className="settings-field">
            <label>Address Line 1</label>
            <input
              name="address_line_1"
              value={settings.address_line_1}
              onChange={handleChange}
              placeholder="27 Shop Street"
            />
          </div>

          <div className="settings-field">
            <label>Address Line 2</label>
            <input
              name="address_line_2"
              value={settings.address_line_2}
              onChange={handleChange}
              placeholder="Drogheda, Co. Louth"
            />
          </div>

          <div className="settings-field">
            <label>Receipt Footer</label>
            <input
              name="receipt_footer"
              value={settings.receipt_footer}
              onChange={handleChange}
              placeholder="Thank you for shopping with us"
            />
          </div>
        </div>
      </div>

      <div className="settings-card">
       <h2>Printer Settings</h2>

        <div className="settings-grid">
         

          <div className="settings-field">
            <label>Printer Name</label>
            <input
              name="printer_name"
              value={settings.printer_name}
              onChange={handleChange}
              placeholder="Tysso Thermal Receipt Printer"
            />
          </div>
        </div>
      </div>

      {message && <div className="settings-success">{message}</div>}
      {error && <div className="settings-error">{error}</div>}

      <div className="settings-actions">
        <button onClick={saveSettings}>Save Shop Settings</button>
      </div>
    </div>
  );
}

export default ShopSettingsPage;